module.exports = __webpack_public_path__ + "static/media/health.122a56c8.mp3";